import React, { useEffect, useState } from "react";
import styles from "./formCategory.module.css";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import AppInput from "component/inputs/AppInput";
import TextField from "component/textField/TextField";
import LabeledSelect from "component/select/labeledSelect/LabeledSelect";
import { useGetCities, useGetLGA, useGetStates } from "api/queries/dashboard/misc";
import ValidationMessage from "component/validationMessage/ValidationMessage";
import form_icon from "assets/images/application-form-icon.svg";
import { getResponsiveModalWidth } from "utils/helpers";
import ModalLayout from "component/modalLayout/ModalLayout";
import Declaration from './modals/declaration/Declaration.jsx'
const propertyIdentifier = [
  {
    label: "Lease Hold",
    value: "lease hold",
  },
  {
    label: "Certificate of Occupancy",
    value: "certificate of occupancy",
  },
  {
    label: "Freehold",
    value: "freehold",
  },
  {
    label: "Registered Deed of Assignment",
    value: "registered deed of assignment",
  },
];
const propertyType = [
  {
    label: "Semi-Detached",
    value: "semi-detached",
  },
  {
    label: "Town House",
    value: "town house",
  },
  {
    label: "Flat",
    value: "flat",
  },
  {
    label: "Bungalow",
    value: "bungalow",
  },
  {
    label: "Terrace",
    value: "terrace",
  },
  {
    label: "Others",
    value: "others",
  },
];
const schemes = [
  {
    label: "Outright Purchase",
    value: "outright purchase",
  },
  {
    label: "Off-Plan",
    value: "Off-Plan",
  },
  {
    label: "Equity Release",
    value: "Equity Release",
  },
];
function PropertyDetails({trigger, formData, setValue, watch, errors, register }) {
  const { states, loading } = useGetStates();
  const { LGA, setStateID } = useGetLGA();
  const { cities, setStateID: setStateIdForCities } = useGetCities();
  const state = watch("propertyState", "");
  const price = watch("propertyPrice", "");
  const [width, setWidth] = useState(getResponsiveModalWidth());
  const [openDeclaration, setOpenDeclaration] = useState(false);

  useEffect(() => {
    getResponsiveModalWidth();
    window.addEventListener("resize", () => {
      setWidth(getResponsiveModalWidth());
    });
  }, []);


  useEffect(() => {
    setValue("propertyEquityContribution", 0.2 * price);
    // trigger("propertyEquityContribution")
  }, [price]);

  useEffect(() => {
    const code = states?.find((_state)=>{
      return _state.name === state
    })?.state_code
    setStateID(code)
    setStateIdForCities(code)
  }, [state]);


  useEffect(() => {
    if (formData.state) {
      setValue("propertyState", formData.propertyState);
      setStateID(
        states?.find((_state) => {
          return _state.name === formData.propertyState;
        })?.state_code
      );
    }
  }, [states]);

  useEffect(() => {
    setValue("propertyLga", formData?.propertyLga);
  }, [LGA]);

  return (
    <div className={styles.category_tab}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={4}>
          <div className={styles.category}>
            <Typography variant="h6">Property Details</Typography>
            <Typography>
              Please provide details of the mortgage property you wish to apply
              for.
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sm={8}>
          <div className={styles.category_form}>
            <Grid container spacing={2}>
            
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                    required={true}
                    errors={errors}
                    register={register}
                    data={propertyType}
                    name="propertyType"
                    label="Property Type"
                    placeholder="Property Type"
                  />
                </div>
              </Grid>

            
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                    required={true}
                    name="propertyPrice"
                    errors={errors}
                    register={register}
                    label="Property Price"
                    type="text"
                    placeholder="property price"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={styles.field}>
                  <TextField
                    required={true}
                    name="propertyAddress"
                    errors={errors}
                    register={register}
                    label="Address"
                    type="text"
                    placeholder="Insert Address"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                    required={true}
                    name="propertyEquityContribution"
                    errors={errors}
                    register={register}
                    label="Equity Contribution"
                    type="number"
                    placeholder="Equity Contribution"
                  />
                </div>
              </Grid>

              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                    required={true}
                    errors={errors}
                    data={states?.map((state) => {
                      return {
                        label: state.name,
                        value: state.name,
                      };
                    })}
                    register={register}
                    name="propertyState"
                    label="State"
                    placeholder="Select State"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                    required={true}
                    errors={errors}
                    data={LGA?.map((state) => {
                      return {
                        label: state,
                        value: state,
                      };
                    })}
                    register={register}
                    name="propertyLga"
                    label="LGA"
                    placeholder="Select LGA"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                <LabeledSelect
                      required={true}
                      name="propertyCity"
                      register={register}
                      errors={errors}
                      label="City"
                      data={cities}
                      placeholder="Select City"
                    />
              
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={`${styles.field} ${styles.checkbox_field}`}>
                  <label>
                    <input
                      {...register("customerDeclarationStatement")}
                      type="checkbox"
                      name="customerDeclarationStatement"
                    />
                    <Typography>
                      By clicking the checkbox, you agree to our{" "}
                      <span
                        href="/"
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenDeclaration(true);
                        }}
                      >
                        {" "}
                        Customer Declaration Statement.
                      </span>
                    
                    </Typography>
                  </label>
                  <ValidationMessage message={errors?.customerDeclarationStatement?.message} />
                  {/* <AppInput
                    errors={errors}
                    register={register}
                    name="customerDeclarationStatement"
                    label="By clicking the checkbox, you agree to our  Customer Declaration Statement."
                    type="checkbox"
                  /> */}
                </div>
              </Grid>
              {/* <Grid item xs={12} sm={12}>
                <div className={styles.field}>
                  <AppInput
                    errors={errors}
                    register={register}
                    name="bankOpeningConsent"
                    label="By clicking the checkbox, you consent to Stanbic IBTC Opening an Account in your name"
                    type="checkbox"
                  />
                </div>
              </Grid> */}
            </Grid>
          </div>
        </Grid>
      </Grid>
      {openDeclaration && (
          <ModalLayout
          icon={form_icon}
            title="Customer Declaration"
            handleClose={() => {
              setOpenDeclaration(false);
            }}
            width={width}
            openModal={openDeclaration}
            children={
             <Declaration/>
            }
          />
        )}
    </div>
  );
}

export default PropertyDetails;